import { createAsyncThunk } from "@reduxjs/toolkit";
import { protectedApi } from "../../app/utils/common/protectedApi";
import { APIS } from "../../app/utils/constants/apiConstant";
import { BASE_URL } from "../../app/utils/common/baseUrl";
import axios from "axios";

export const getEmployeesAPI = createAsyncThunk(
    "employee/getEmployeesAPI",
    async ({ page, limit, role, filterBy = "active" }, { rejectWithValue }) => {
        try {
             // Build query parameters dynamically
             const queryParams = [];

             if (page) queryParams.push(`page=${page}`);
             if (limit) queryParams.push(`limit=${limit}`);
             if (role) queryParams.push(`roleId=${role}`);
             if (filterBy) queryParams.push(`filterBy=${filterBy}`);
             
             const queryString = queryParams.length > 0 ? `?${queryParams.join('&')}` : '';
            const response = await protectedApi({
                url: `${APIS.EMPLOYEE_LIST}/${queryString}`,
                method: "GET",
            });

            return response.data;
        } catch (error) {
            console.log(error)
            return rejectWithValue(error.response.data.error);
        }
    }
);

export const getEmployeeDirectoryAPI = createAsyncThunk(
    "employee/getEmployeeDirectoryAPI",
    async (_, { rejectWithValue }) => {
        const paths = [APIS.EMPLOYEE_DIRECTORY, APIS.EMPLOYEE_DIRECTORY_FALLBACK];
        let lastError;
        for (const url of paths) {
            try {
                const response = await protectedApi({ url, method: "GET" });
                return response.data;
            } catch (error) {
                lastError = error;
                const status = error?.response?.status;
                if (status === 404) continue;
                return rejectWithValue(error?.response?.data?.error || error);
            }
        }
        return rejectWithValue({
            message:
                "Employee directory is not available on this server. Deploy the latest TCS API (includes GET /api/profile/directory).",
            responseCode: 1,
        });
    }
);

export const createEmployee = createAsyncThunk(
    "employee/createEmployee",
    async (data, { rejectWithValue }) => {
        try {
            const response = await protectedApi({
                url: `${APIS.CREATE_USER}`,
                method: "POST",
                data
            });

            return response.data;
        } catch (error) {
            console.log(error)
            return rejectWithValue(error.response.data.error);
        }
    }
);
export const updateEmployee = createAsyncThunk(
    "employee/updateEmployee",
    async ({ id, payload }, { rejectWithValue }) => {
        try {
            const response = await protectedApi({
                url: `${APIS.UPDATE_USER.replace(":userId", id)}`,
                method: "PUT",
                data: payload
            });

            return response.data;
        } catch (error) {
            console.log(error)
            return rejectWithValue(error.response.data.error);
        }
    }
);
export const deleteEmployee = createAsyncThunk(
    "employee/deleteEmployee",
    async ({ userId, lastWorkingDate = null }, { rejectWithValue }) => {
        try {
            const response = await protectedApi({
                url: `${APIS.DELETE_USER.replace(":userId", userId)}`,
                method: "DELETE",
                data: lastWorkingDate ? { lastWorkingDate } : {},
            });

            return response.data;
        } catch (error) {
            return rejectWithValue(error?.response?.data?.error || error);
        }
    }
);
export const uploadFile = createAsyncThunk(
    "employee/uploadFile",
    async (formData, { rejectWithValue }) => {
        try {
            const response = await protectedApi({
                url: APIS.UPLOAD_FILE,
                method: "POST",
                data: formData,
                headers: {
                    "Content-Type": "multipart/form-data",
                },
                _dataEncrypted: true,
            });


            return response.data;
        } catch (error) {
            console.log(error)
            return rejectWithValue(error.response.data.error);
        }
    }
);

export const updateAttendanceCodeAPI = createAsyncThunk(
    "employee/updateAttendanceCodeAPI",
    async ({ id, attendanceEmployeeCode }, { rejectWithValue }) => {
        try {
            const response = await protectedApi({
                url: `${APIS.UPDATE_ATTENDANCE_CODE.replace(":userId", id)}`,
                method: "PUT",
                data: { attendanceEmployeeCode }
            });
            return response.data;
        } catch (error) {
            return rejectWithValue(error?.response?.data?.error || error);
        }
    }
);

export const updateEmployeeCodeAPI = createAsyncThunk(
    "employee/updateEmployeeCodeAPI",
    async ({ id, employeeCode }, { rejectWithValue }) => {
        try {
            const response = await protectedApi({
                url: `${APIS.UPDATE_EMPLOYEE_CODE.replace(":userId", id)}`,
                method: "PUT",
                data: { employeeCode },
            });
            return response.data;
        } catch (error) {
            return rejectWithValue(error?.response?.data?.error || error);
        }
    }
);